


import '../SCSS/App.scss';
import Navigation from '../component/nav-bar';
// import Footer from '../component/Footer';



const About = () => {
    return (
       

      <div className="p-5">

          {/* <Navigation /> */}
          

           <h1>I am a About page</h1>

           <h1>This page are not available </h1>



        
      </div>
       
   )
 }


export default About;